import { Navigate } from "react-router-dom";
import { MAIN } from "constants/route";

import { useSelector } from "react-redux";

export default function ProtectedRoute({ children }) {
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  if (!isLogin) {
    return <Navigate to={MAIN} replace />;
  }

  return children;
}
